import { render, staticRenderFns } from "./ScheduleRecommendationTableForm.vue?vue&type=template&id=877c6f30"
import script from "./ScheduleRecommendationTableForm.vue?vue&type=script&lang=js"
export * from "./ScheduleRecommendationTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports